import { useState, type FormEvent } from 'react'
import { mensagemDoErro } from '../../api/erros'
import { useRetirarDocumento } from '../../api/queries/documentos'
import { Botao } from '../../components/Botao'
import { CampoDeTextoLongo } from '../../components/campos'
import { Dialogo } from '../../components/Dialogo'
import { TEXTOS } from '../../lib/glossario'
import type { DocumentoDoContrato } from '../../types/documentos'

/**
 * Tirar um documento da consulta, com o motivo — e nomeando o documento, para não haver engano.
 *
 * @param props o documento e o que fazer ao fechar
 * @returns o diálogo
 */
export function DialogoDeRetirada({ documento, aoFechar }: { documento: DocumentoDoContrato; aoFechar: () => void }) {
  const t = TEXTOS.documentos.retirada
  const retirada = useRetirarDocumento()
  const [motivo, setMotivo] = useState('')
  const [tentou, setTentou] = useState(false)
  const curto = motivo.trim().length < 10

  function confirmar(evento: FormEvent) {
    evento.preventDefault()
    setTentou(true)
    if (curto) {
      return
    }
    retirada.mutate({ id: documento.id, motivo: motivo.trim() }, { onSuccess: aoFechar })
  }

  return (
    <Dialogo
      titulo={`${t.titulo}: ${documento.titulo}`}
      descricao={t.descricao}
      aoFechar={aoFechar}
      rodape={
        <>
          <Botao aparencia="secundario" onClick={aoFechar} disabled={retirada.isPending}>
            Cancelar
          </Botao>
          <Botao aparencia="perigo" type="submit" form="retirada-de-documento" disabled={retirada.isPending}>
            {t.confirmar}
          </Botao>
        </>
      }
    >
      <form id="retirada-de-documento" onSubmit={confirmar} noValidate className="space-y-3">
        <CampoDeTextoLongo
          rotulo={t.motivo}
          ajuda={t.motivoAjuda}
          value={motivo}
          rows={3}
          maxLength={500}
          erro={tentou && curto ? 'Escreva o motivo, com pelo menos 10 caracteres.' : undefined}
          onChange={(evento) => setMotivo(evento.currentTarget.value)}
        />
        {retirada.isError && (
          <p role="alert" className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-800">
            {mensagemDoErro(retirada.error)}
          </p>
        )}
      </form>
    </Dialogo>
  )
}
